import type { SessionMessage } from '@camino-solutions/share/proto/common/services';

/**
 * Stream-en erkezo uzenet
 */
export class SessionHandleMessageAction {
  static readonly type = '[Session] handle session message';

  constructor(readonly sessionMessage: SessionMessage) {}
}
